import save from '@/tools/save'

export default ({ store }, inject) => {
  if (process.browser) {
    return inject('save', save)
  }
}
